import React from 'react';
import { Redirect } from "react-router-dom";
import { PanelStack } from "@blueprintjs/core";
import '../assets/components/Login.css';

import Auth from '../services/Auth';

import SignInPanel from '../components/Login/SignInPanel';

const rowStyle = {
    marginTop: '15px'
};

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signing: false,
            redirect: false,
            googleSignInError: null,
            currentPanelStack: [{
                component: SignInPanel,
                props: {
                    panelNumber: 1,
                    onSignInSuccess: () => this.setState({ redirect: true })
                },
                title: "Login"
            }]
        }
    }

    render() {
        if (Auth.isAuth())
            return (<Redirect to="/" />)
        if (this.state.redirect)
            return (<Redirect to="/" />)
        return (
            <div className="row bp3-dark animated fadeIn" style={rowStyle}>
                <div className="col-xs-12">
                    <div className="logo-text text-center">
                        VisualSense.fr
                        <br />
                        <small>
                            Shared Visual Experiences
                        </small>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4">
                    <PanelStack
                        initialPanel={this.state.currentPanelStack[0]}
                        className='sign-in-up-panel-stack' />
                </div>
            </div>
        );
    }

    componentWillMount() {
        document.body.style.background = "#606c88";
        document.body.style.background = "-webkit-linear-gradient(to right, #3f4c6b, #606c88)";
        document.body.style.background = "linear-gradient(to right, #3f4c6b, #606c88)";
    }

    componentWillUnmount() {
        document.body.style.background = null;
    }
}

export default Login;
